export const IANA_TIMEZONE_LIST = Intl.supportedValuesOf('timeZone');

export const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as const;

export const TIMESTAMP_REGEX =
  /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;

export const TIME_REGEX = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;
export const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD format

export const MS_IN_S = 1000;
export const S_IN_M = 60;
export const M_IN_H = 60;
export const MINUTE_IN_MS = S_IN_M * 1000;
export const HOUR_IN_MS = M_IN_H * MINUTE_IN_MS;
export const DAY_IN_MS = 24 * HOUR_IN_MS;

// https://en.wikipedia.org/wiki/ISO_8601. However, years before 1583 (the first full year following the
// introduction of the Gregorian calendar) are not automatically allowed by the standard (it throw "Invalid ISO-8601 format" error).
// But that won't work, parsing failed for 1882 year and earlier. Discussed with BA to use 2024 as a min year.
export const ISO8601_MIN_YEAR = 2024;

export const DEFAULT_DATE_FORMAT_STRING = 'MM/dd/yyyy HH:mm zzz';
export const FALLBACK_HHMM = '--:--';
export const PLACEHOLDER_DATE_TIME_FORMAT = 'mm/dd/yyyy --:--';
